<template>
  <div class="dashboard-bg" :style="`padding-left: ${margin}`">
    <div class="dashboard-grid">

      <div v-for="group in groups" :key="group.groupName" :class="`grid-item grid-item--${group.slot}`">
        <div class="glass-card">

          <!-- Header: ikona + naslov -->
          <div class="card-header">
            <v-icon size="24" color="#00838F">{{ group.icon }}</v-icon>
            <span class="category-title">{{ group.groupName }}</span>
          </div>

          <div class="card-divider"></div>

          <!-- List -->
          <div :class="['card-list', group.horizontal && 'card-list--horizontal']">
            <router-link
              v-for="(item, i) in group.items"
              :key="i"
              :to="item.to"
              class="list-item"
            >
              <v-icon size="17" color="#00BCD4" class="list-item__icon">{{ item.icon }}</v-icon>
              <span class="list-item__label">{{ item.itemName }}</span>
            </router-link>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import 'jspdf-autotable'
import state from '@/state'
import EventBus from '@/plugins/event-bus'

export default {
  name: 'Reports',
  inject: ['showMsgBox', 'showLoader', 'hideLoader'],
  data () {
    return {
      margin: '0px'
    }
  },
  mounted () {
    this.margin = state.getMargin()
    EventBus.$on('set-mini', () => {
      this.margin = state.getMargin()
    })
  },
  computed: {
    hasWarehouse () {
      return state.getCurrentCompany().warehouse === 'module'
    },
    isAdmin () {
      return !!(state.getUser()?.roles?.SUPERADMIN || state.getUser()?.roles?.ADMIN)
    },
    targetModifier () {
      const sideNav = this.$route.meta.sideNav
      if (sideNav === 'Company') return 'company'
      if (sideNav === 'PointOfSale' || sideNav === 'CashRegister') return 'pointOfSale'
      return ''
    },
    groups () {
      const all = [
        {
          groupName: 'Promet',
          slot: 'promet',
          icon: 'mdi-chart-line',
          items: [
            { itemName: 'Rekapitulacija prometa', icon: 'mdi-chart-bar', to: { name: `${this.targetModifier}.all-reports.recapitulation` } },
            { itemName: 'Rekapitulacija po kupcima', icon: 'mdi-account-group', to: { name: `${this.targetModifier}.all-reports.recapitulationBuyers` } },
            { itemName: 'Kartica kupca', icon: 'mdi-card-account-details-outline', to: { name: `${this.targetModifier}.all-reports.customerCard` } },
            { itemName: 'Zbirni promet', icon: 'mdi-table-eye', to: { name: `${this.targetModifier}.all-reports.groupageCollection` } },
            { itemName: 'Promet artikala', icon: 'mdi-package-variant', to: { name: `${this.targetModifier}.all-reports.itemReport` } },
            { itemName: 'Promet po virmanima', icon: 'mdi-bank-transfer', to: { name: `${this.targetModifier}.all-reports.recapitulationVirmans` } }
          ]
        },
        {
          groupName: 'Financije',
          slot: 'financije',
          icon: 'mdi-bank-outline',
          items: [
            { itemName: 'Porezno izvješće', icon: 'mdi-file-document-outline', to: { name: `${this.targetModifier}.all-reports.taxReport` } },
            { itemName: 'Porez na potrošnju', icon: 'mdi-cash-multiple', to: { name: `${this.targetModifier}.all-reports.pnpReport` } },
            { itemName: 'Rekapitulacija napojnica', icon: 'mdi-hand-coin', to: { name: `${this.targetModifier}.all-reports.recapitulationTips` } },
            { itemName: 'Nivelacija', icon: 'mdi-swap-vertical-bold', to: { name: `${this.targetModifier}.all-reports.nivelacija` } },
            { itemName: 'Knjiga prometa', icon: 'mdi-book-open-variant', to: { name: `${this.targetModifier}.all-reports.knjigaPrometa` } }
          ]
        },
        {
          groupName: 'Artikli',
          slot: 'skladiste',
          icon: 'mdi-tag-multiple-outline',
          items: [
            { itemName: 'Pregled cjenika', icon: 'mdi-format-list-bulleted-square', to: { name: `${this.targetModifier}.all-reports.itemPricelistReport` } }
          ]
        },
        {
          groupName: 'Skladište',
          slot: 'artikli',
          icon: 'mdi-warehouse',
          warehouseOnly: true,
          items: [
            { itemName: 'Materijalna kartica', icon: 'mdi-card-text-outline', to: { name: `${this.targetModifier}.all-reports.recapitulationRmk` } },
            { itemName: 'Inventurni zapisnik', icon: 'mdi-clipboard-list-outline', to: { name: `${this.targetModifier}.all-reports.inventories` } },
            { itemName: 'Skladišna kartica', icon: 'mdi-warehouse', to: { name: `${this.targetModifier}.all-reports.warehouseCard` } }
          ]
        },
        {
          groupName: 'Analitika',
          slot: 'analitika',
          icon: 'mdi-chart-areaspline',
          adminOnly: true,
          horizontal: true,
          items: [
            {
              itemName: 'Statistike prihoda',
              icon: 'mdi-chart-box',
              to: { name: `${this.targetModifier}.all-reports.statistikeProhoda` }
            },
            {
              itemName: 'Heatmap',
              icon: 'mdi-clock-time-four-outline',
              to: { name: `${this.targetModifier}.all-reports.heatmapProhoda` }
            },
            {
              itemName: 'Usporedba po periodima',
              icon: 'mdi-chart-bar',
              to: { name: `${this.targetModifier}.all-reports.usporedbaGodina` }
            },
            {
              itemName: 'Promet po zaposleniku',
              icon: 'mdi-account-group',
              to: { name: `${this.targetModifier}.all-reports.promZaposlenika` }
            },
            {
              itemName: 'Usporedba tjedana',
              icon: 'mdi-calendar-week',
              to: { name: `${this.targetModifier}.all-reports.usporedbaPoTjednima` }
            },
            {
              itemName: 'Promet po smjenama',
              icon: 'mdi-clock-time-four-outline',
              to: { name: `${this.targetModifier}.all-reports.smjeneProhoda` }
            },
            {
              itemName: 'Storna i popusti',
              icon: 'mdi-undo-variant',
              to: { name: `${this.targetModifier}.all-reports.stornoAnaliza` }
            },
            {
              itemName: 'Napojnice',
              icon: 'mdi-hand-coin',
              to: { name: `${this.targetModifier}.all-reports.napojniceReport` }
            },
            {
              itemName: 'KDS analitika',
              icon: 'mdi-chef-hat',
              to: { name: `${this.targetModifier}.all-reports.kdsReport` }
            }
          ]
        }
      ]
      return all.filter(g => {
        if (g.warehouseOnly && !this.hasWarehouse) return false
        if (g.adminOnly && !this.isAdmin) return false
        return true
      })
    }
  }
}
</script>

<style scoped>
.dashboard-bg {
  min-height: 100vh;
  background: #F8FAFC;
  padding: 28px 24px;
  box-sizing: border-box;
}

.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: auto auto;
  column-gap: 20px;
  row-gap: 24px;
  max-width: 1200px;
  margin: 0 auto;
  align-items: stretch;
}

.grid-item {
  display: flex;
}

.grid-item--analitika      { grid-column: 1 / span 12; grid-row: 1; }
.grid-item--promet         { grid-column: 1 / span 5;  grid-row: 2; }
.grid-item--financije      { grid-column: 6 / span 4;  grid-row: 2; }
.grid-item--skladiste      { grid-column: 10 / span 3; grid-row: 2; }
.grid-item--artikli        { grid-column: 1 / span 12; grid-row: 3; }

@media (max-width: 900px) {
  .grid-item--promet,
  .grid-item--financije,
  .grid-item--skladiste,
  .grid-item--artikli,
  .grid-item--analitika { grid-column: span 12; grid-row: auto; }

  .card-list--horizontal .list-item { flex: 0 0 100%; }
}

.glass-card {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid #E0E6ED;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  display: flex;
  flex-direction: column;
}

.glass-card:hover {
  border-color: #00BCD4;
  box-shadow: 0 10px 25px -5px rgba(0, 188, 212, 0.1);
}

.card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 20px 14px;
}

.category-title {
  font-size: 18px;
  font-weight: 700;
  color: #2d3748;
  letter-spacing: 0.2px;
}

.card-divider {
  height: 1px;
  background: #F0F4F8;
  margin: 0 16px;
}

.card-list {
  padding: 16px 12px 12px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
}

.list-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 10px;
  border-radius: 6px;
  text-decoration: none;
  transition: background 0.2s ease, color 0.2s ease;
}

.list-item:hover {
  background: rgba(0, 188, 212, 0.04);
}

.list-item:hover .list-item__label {
  color: #00BCD4;
}

.list-item:hover .list-item__icon >>> .v-icon__svg,
.list-item:hover .list-item__icon >>> .v-icon {
  color: #00BCD4 !important;
}

.list-item__icon {
  flex-shrink: 0;
}

.list-item__label {
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  transition: color 0.2s ease;
}

.card-list--horizontal {
  flex-direction: row;
  flex-wrap: wrap;
}

.card-list--horizontal .list-item {
  flex: 0 0 calc(33.333% - 8px);
  min-width: 200px;
}

</style>
